import { CENTRAL_WAREHOUSE } from '@/api/inventory.api';
import type { CurrentUser } from '@/api/types';

/**
 * Per-branch access, on the screen side (docs/FILIALE-ACCES.md).
 *
 * The API is what enforces it — every list arrives already narrowed, and a
 * write into another branch is refused. What is here only keeps the screens
 * from offering what the API would refuse: the central warehouse as a default,
 * another branch's cabinet in a picker, a button that closes the clinic's day.
 */

/** The branches this person is limited to, or null when they see all of them. */
export function branchLimitOf(user: CurrentUser | null | undefined): string[] | null {
  const s = user?.branchScope;
  if (!user || user.kind !== 'staff' || !s || s.allBranches || s.branchIds.length === 0) {
    return null;
  }
  return s.branchIds;
}

/** May this person see a row of this branch? A row of no branch is the whole clinic's. */
export function seesBranchOf(
  user: CurrentUser | null | undefined,
  branchId: string | null | undefined,
): boolean {
  const branches = branchLimitOf(user);
  return !branches || !branchId || branches.includes(branchId);
}

/**
 * Where stock starts on a screen: the central warehouse, or — for a member
 * limited to some branches, who may not hold the central one — their first
 * branch's warehouse.
 */
export function homeWarehouseOf(user: CurrentUser | null | undefined): string {
  const first = branchLimitOf(user)?.[0];
  return first ? `branch:${first}` : CENTRAL_WAREHOUSE;
}
